/* Gemi PDP theme sections (gemi-pdp-*.liquid). One script for all of them:
   - works with any subset / order / duplicate of the sections and any blocks removed or added in the theme editor
   - content is rendered by Liquid; this only adds behaviour (scent switch, plans, bundles, cart, rails, video, reviews)
   - re-initialises whatever the theme editor re-renders (shopify:section:load) and reacts to block selection
   - cart = native /cart/add.js, then the theme / Kaching cart drawer opens */
(() => {
'use strict';
if (window.GemiPDP) return;            // every section includes this file; run once
const G = window.GemiPDP = { version: 2 };

/* ---------------- helpers ---------------- */
const $ = (s, r = document) => (r && r.querySelector ? r.querySelector(s) : null);
const $$ = (s, r = document) => (r && r.querySelectorAll ? [...r.querySelectorAll(s)] : []);
const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const clampQty = n => Math.max(1, Math.min(99, parseInt(n, 10) || 1));
const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
const imgW = (url, w) => !url ? '' : /[?&]width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url + (url.includes('?') ? '&' : '?') + 'width=' + w;
// init markers live under data-gp-done-* so they never collide with the data-gp-* hooks the markup uses
const once = (el, key) => { if (!el || el.dataset['gpDone' + key]) return false; el.dataset['gpDone' + key] = '1'; return true; };
const words = (s, n) => { const w = String(s || '').trim().split(/\s+/); return w.length > n ? w.slice(0, n).join(' ') + '...' : w.join(' '); };

let DATA = null, dataEl;
function data() {
  const el = $('[data-gp-data]');
  if (el !== dataEl) {
    dataEl = el; DATA = null;
    if (el) try { DATA = JSON.parse(el.textContent); } catch (e) { console.warn('gemi-pdp: bad data', e); }
    // every product exposes .variant (the one picked in the variant picker, else the selected/first available) and .plans
    if (DATA) (DATA.products = DATA.products || DATA.scents || []).forEach(pr => {
      pr.variants = pr.variants || [];
      Object.defineProperty(pr, 'variant', { configurable: true, get() {
        const id = S.vsel[pr.handle] || pr.selected;
        return pr.variants.find(v => String(v.id) === String(id)) || pr.variants.find(v => v.available) || pr.variants[0] || { id: 0, options: [], available: false, price: 0, compare: 0, plans: [] };
      } });
      Object.defineProperty(pr, 'plans', { configurable: true, get() { return this.variant.plans || []; } });
    });
  }
  return DATA;
}
const scents = () => (data() && data().products) || [];
const scent = h => scents().find(s => s.handle === h);
const main = () => $('[data-gp="main"]');
function money(cents) {
  const n = Number(cents) / 100;
  const fmt = String((data() && data().moneyFormat) || '${{amount}}').replace(/<[^>]*>/g, '');
  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) =>
    k === 'amount_no_decimals' ? Math.round(n).toLocaleString('en-US')
      : k === 'amount_with_comma_separator' ? n.toFixed(2).replace('.', ',')
        : k === 'amount_no_decimals_with_comma_separator' ? Math.round(n).toLocaleString('de-DE')
          : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
}
function bind(key, text, scope = document) { $$(`[data-gp-bind="${key}"]`, scope).forEach(el => { el.textContent = text; }); }
let toastT;
function toast(msg) {
  let t = $('.gp-toast-host .toast');
  if (!t) { const h = document.createElement('div'); h.className = 'gemi-pdp gp-toast-host'; h.innerHTML = '<div class="toast" role="status" aria-live="polite"></div>'; document.body.appendChild(h); t = $('.toast', h); }
  t.textContent = msg; t.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('is-on'), 2600);
}
const setStars = (el, avg) => el && el.style.setProperty('--pct', Math.max(0, Math.min(100, avg / 5 * 100)) + '%');

/* ---------------- state ---------------- */
const S = { handle: null, purchase: 'once', plan: null, vsel: {} };

/* ---------------- product info (main section) ---------------- */
const sortPlans = pl => [...(pl || [])].sort((a, b) => (/recommended/i.test(b.label) ? 1 : 0) - (/recommended/i.test(a.label) ? 1 : 0));
function renderPlans(sc) {
  const m = main(); if (!m || !sc) return;
  const pl = sortPlans(sc.plans);
  if (!pl.find(x => String(x.id) === String(S.plan))) S.plan = pl.length ? String(pl[0].id) : null;
  const sub = $('[data-opt="sub"]', m); if (sub) sub.hidden = !pl.length;
  if (!pl.length && S.purchase === 'sub') setPurchase('once');
  const row = $('[data-gp-freq]', m);
  if (row) row.innerHTML = pl.map(x => `<button type="button" class="freq__pill${String(x.id) === S.plan ? ' is-on' : ''}" data-plan="${x.id}" data-price="${x.price}">${esc(String(x.label).replace(/\s*-\s*recommended/i, ''))}${/recommended/i.test(x.label) ? '<small>Recommended</small>' : ''}</button>`).join('');
  const cur = pl.find(x => String(x.id) === S.plan);
  if (cur) bind('subPrice', money(cur.price), m);
}
function setPurchase(kind) {
  const m = main(); S.purchase = kind; if (!m) return;
  $$('.opt', m).forEach(o => { const on = o.dataset.opt === kind; o.classList.toggle('is-on', on); const i = $('input', o); if (i) i.checked = on; });
  const note = $('[data-gp-subnote]', m); if (note) note.hidden = kind !== 'sub'; syncExpress();
}
function renderGallery(sc) {
  const m = main(), tr = $('[data-gp-track]', m), th = $('[data-gp-thumbs]', m);
  if (!tr || !sc) return;
  const slides = (sc.images || []).map(i => ({ type: 'img', url: i.url, alt: i.alt || sc.title }));
  if (sc.video && sc.video.src) slides.splice(Math.min(3, slides.length), 0, { type: 'video', url: sc.video.src, poster: sc.video.poster });
  tr.innerHTML = slides.map((s, i) => `<div class="gal__slide" data-i="${i}">${s.type === 'video'
    ? `<video src="${esc(s.url)}" poster="${esc(s.poster || '')}" muted loop playsinline preload="none" aria-label="${esc(sc.title)} video"></video>`
    : `<img src="${esc(imgW(s.url, 1100))}" srcset="${esc(imgW(s.url, 600))} 600w, ${esc(imgW(s.url, 900))} 900w, ${esc(imgW(s.url, 1300))} 1300w" sizes="(max-width: 989px) 100vw, 46vw" alt="${esc(s.alt)}" width="1100" height="1375"${i ? ' loading="lazy"' : ''}>`}</div>`).join('');
  if (th) th.innerHTML = slides.map((s, i) => `<button type="button" class="gal__thumb${i ? '' : ' is-on'}" data-go="${i}" aria-label="Show ${s.type === 'video' ? 'video' : 'image ' + (i + 1)}"><img src="${esc(imgW(s.type === 'video' ? s.poster : s.url, 300))}" alt="" loading="lazy" width="300" height="375">${s.type === 'video' ? '<svg class="gp-play" viewBox="0 0 40 40" aria-hidden="true"><circle cx="20" cy="20" r="20" fill="rgba(255,255,255,.75)"/><path d="m16 13 11 7-11 7z" fill="#1c1c1a"/></svg>' : ''}</button>`).join('');
  tr.scrollLeft = 0;
  const badge = $('.gal__badge', m); if (badge) badge.classList.remove('is-hidden');
}
function renderVariant(sc) {
  const m = main(); if (!m || !sc) return;
  const v = sc.variant;
  bind('price', money(v.price), m);
  $$('[data-gp-bind="compare"]', m).forEach(el => { const on = v.compare > v.price; el.hidden = !on; if (on) el.textContent = money(v.compare); });
  renderPlans(sc);
  const atc = $('[data-gp-atc]', m);
  if (atc && !atc.classList.contains('is-done')) { atc.disabled = !v.available; atc.textContent = v.available ? atc.dataset.label : atc.dataset.soldout; }
  // option buttons: current value on, values with no available combination crossed out
  const opts = v.options || [];
  $$('[data-gp-variants] .gp-opt', m).forEach(fs => {
    const i = +fs.dataset.optIndex, val = opts[i];
    const lab = $('[data-gp-optval]', fs); if (lab) lab.textContent = val || '';
    $$('.gp-vbtn', fs).forEach(b => {
      const on = b.dataset.value === val;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      const ok = sc.variants.some(x => x.available && (x.options || [])[i] === b.dataset.value && (x.options || []).every((o, j) => j === i || o === opts[j]));
      b.classList.toggle('is-na', !ok);
    });
  });
  syncExpress();
}
function syncExpress() {
  const m = main(); const f = m && $('.gp-express', m); if (!f) return;
  const sc = scent(S.handle); if (!sc) return; const v = sc.variant;
  const id = $('[data-gp-express-id]', f), q = $('[data-gp-express-qty]', f), qi = $('[data-gp-qty]', m);
  if (id && id.value !== String(v.id)) { id.value = v.id; id.dispatchEvent(new Event('change', { bubbles: true })); }
  if (q) q.value = qi ? clampQty(qi.value) : 1;
  f.hidden = S.purchase === 'sub' || !v.available;
}
function jumpToImage(url, instant) {
  const tr = $('[data-gp-track]', main()); if (!tr || !url) return;
  const base = u => String(u || '').split('?')[0].replace(/^https?:/, '');
  const slides = $$('.gal__slide', tr), i = slides.findIndex(sl => { const im = $('img', sl); return im && base(im.getAttribute('src')) === base(url); });
  if (i >= 0) tr.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
}
function renderMain(sc) {
  const m = main(); if (!m || !sc) return;
  if (sc.scent) bind('name', sc.name);
  $$('[data-gp-bind="desc"]', m).forEach(el => { el.textContent = el.dataset.gpSource === 'product' ? words(sc.productDesc, +el.dataset.words || 40) : (sc.desc || sc.productDesc || ''); });
  $$('.sw[data-scent]', m).forEach(b => { const on = b.dataset.scent === sc.handle; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
  renderVariant(sc);
  const rt = $('[data-gp-rating]', m);
  if (rt) rt.hidden = !(sc.rating > 0);   // never show a rating the product doesn't have; Judge.me fills it in below
  if (sc.rating > 0) { bind('avg', (+sc.rating).toFixed(1), m); setStars($('.gp-rating .stars', m), +sc.rating); bind('count', sc.count, m); }
  renderGallery(sc);
}
function switchScent(h, push) {
  const sc = scent(h);
  if (!sc) return;
  S.handle = h;
  renderMain(sc);
  applyScentToSections();
  if (push && history.replaceState) {
    const u = new URL(location.href);
    if (h === (data() && data().default)) u.searchParams.delete('scent'); else u.searchParams.set('scent', h);
    history.replaceState(history.state, '', u.pathname + u.search + u.hash);
  }
  $$('[data-gp="reviews"]').forEach(sec => { if (sec.dataset.gpLoaded) loadReviews(sec, 1); });
  loadMainRating();
}
function applyScentToSections() {
  const h = S.handle; if (!h) return;
  $$('[data-gp="frag"]').forEach(f => {
    const panels = $$('[data-scent-panel]', f); if (!panels.length) return;
    const match = panels.find(p => p.dataset.scentPanel === h) || panels[0];
    panels.forEach(p => { p.hidden = p !== match; });
  });
  $$('[data-gp="xs"] .pc[data-h]').forEach(c => { c.hidden = c.dataset.h === h; });
  $$('[data-gp="xs"] [data-gp-rail]').forEach(syncRail);
}

/* ---------------- bundles ---------------- */
const MAX_BUNDLE = 99;
function bundleState(bun) { return bun._gpSel || (bun._gpSel = {}); }
function updateBundle(bun) {
  const n = +bun.dataset.n || 0, sel = bundleState(bun), tot = Object.values(sel).reduce((a, b) => a + b, 0);
  const c = $('[data-count]', bun); if (c) c.textContent = tot;
  const bar = $('.bun__bar i', bun); if (bar) bar.style.width = (n ? Math.min(100, tot / n * 100) : 0) + '%';
  $$('.pick', bun).forEach(li => {
    const q = sel[li.dataset.k] || 0, ok = li.dataset.available !== 'false';
    const o = $('output', li); if (o) o.textContent = q;
    li.classList.toggle('has', q > 0);
    const minus = $('[data-step="-1"]', li), plus = $('[data-step="1"]', li);
    if (minus) minus.disabled = !q;
    if (plus) plus.disabled = tot >= MAX_BUNDLE || !ok;
  });
  // "5 or more": the bundle size is the minimum; button + totals follow what's picked
  const add = $('.bun__add', bun);
  if (add) {
    add.disabled = tot < n;
    const count = Math.max(tot, n), per = +bun.dataset.per || 0, wrap = bun.closest('[data-gp-bundles]'), base = +(wrap && wrap.dataset.base) || 0;
    const label = (add.dataset.addLabel || 'Add [n] to bag').replace('[n]', count);
    add.innerHTML = `${esc(label)} · ${esc(money(per * count))}${base > per ? ` <s>${esc(money(base * count))}</s>` : ''}`;
  }
}

/* ---------------- cart (native theme cart; Kaching / theme drawer picks it up) ---------------- */
let cartQ = Promise.resolve();
function addItems(items) {
  return (cartQ = cartQ.catch(() => { }).then(async () => {
    const r = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items }) });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) { toast(j.description || j.message || 'Could not add to bag. Please try again.'); throw new Error(j.description || 'add failed'); }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    window.dispatchEvent(new CustomEvent('gemi:add', { detail: items }));
    setTimeout(openCart, 350);
    return j;
  }));
}
function cartOpenNow() {
  const k = document.querySelector('kaching-cart');
  if (k && (k.getAttribute('open') !== null || (k.shadowRoot && k.shadowRoot.querySelector('[open], .open, .is-open')) || document.body.classList.contains('kaching-cart-open'))) return true;
  const d = document.querySelector('cart-drawer');
  return !!(d && d.classList.contains('active'));
}
function openCart() {
  if (cartOpenNow()) return;
  if (window.kachingCartApi && window.kachingCartApi.open) return window.kachingCartApi.open();
  const icon = document.querySelector('#cart-icon-bubble, a[href$="/cart"].header__icon--cart, .header__icon--cart');
  if (icon) icon.click(); else location.href = ROOT + 'cart';
}
async function withButton(btn, run) {
  const label = btn.dataset.label || btn.textContent;
  btn.disabled = true; btn.textContent = 'Adding…';
  try { await run(); btn.textContent = 'Added!'; btn.classList.add('is-done'); setTimeout(() => { btn.textContent = label; btn.classList.remove('is-done'); btn.disabled = false; }, 1600); }
  catch { btn.textContent = label; btn.disabled = false; }
}

/* ---------------- reviews (Judge.me public widget feed) ---------------- */
const SHOP = sec => (sec && sec.dataset.judgeme) || (data() && data().judgeme) || 'gemi-staging.myshopify.com';
const productId = sec => { const sc = scent(S.handle); return (sc && sc.id) || (sec && sec.dataset.productId) || ''; };
const jm = (shop, pid, page, per, sort) => `https://judge.me/reviews/reviews_for_widget?url=${encodeURIComponent((data() && data().domain) || location.hostname)}&shop_domain=${encodeURIComponent(shop)}&platform=shopify&page=${page}&per_page=${per}&product_id=${pid}${sort ? '&' + sort : ''}`;
async function loadReviews(sec, page) {
  const st = sec._gp || (sec._gp = { sort: 'sort_by=created_at&sort_dir=desc', req: 0 });
  const pid = productId(sec), list = $('[data-gp-revlist]', sec);
  sec.dataset.gpLoaded = '1';
  if (!pid || !list) return;
  const my = ++st.req; st.page = page;
  try {
    const d = await (await fetch(jm(SHOP(sec), pid, page, +sec.dataset.perPage || 5, st.sort))).json();
    if (my !== st.req) return;
    const avg = +d.average_rating || 0;
    const sum = $('.rev__sum', sec); if (sum) sum.hidden = !d.number_of_reviews;   // no average shown for products without reviews
    bind('avg', avg.toFixed(1), sec); setStars($('.rev__sum .stars', sec), avg);
    list.innerHTML = (d.reviews || []).map(r => {
      const body = new DOMParser().parseFromString(r.body_html || '', 'text/html').body;
      const paras = [...body.querySelectorAll('p')].map(x => x.textContent.trim()).filter(Boolean);
      const text = (paras.length ? paras : [body.textContent.trim()]).map(t => `<p>${esc(t)}</p>`).join('');
      const dt = new Date(r.created_at), date = isNaN(dt) ? '' : `${String(dt.getMonth() + 1).padStart(2, '0')}/${String(dt.getDate()).padStart(2, '0')}/${String(dt.getFullYear()).slice(2)}`;
      const init = (r.reviewer_name || '?').split(/\s+/).map(w => w[0]).join('').slice(0, 2).toUpperCase();
      const sc = scent(S.handle);
      return `<li class="rv">
        <div class="rv__who"><span class="rv__av${r.verified_buyer ? ' v' : ''}">${esc(init)}</span><span><span class="rv__name">${esc(r.reviewer_name)}</span>${r.verified_buyer ? '<br><span class="rv__badge">Verified Buyer</span>' : ''}</span></div>
        <div class="rv__main"><div class="rv__head"><span class="stars stars--sm" style="--pct:${(+r.rating || 0) * 20}%" aria-label="${+r.rating || 0} out of 5 stars"></span>${r.title ? `<span class="rv__title">${esc(r.title)}</span>` : ''}</div>
          <div class="rv__body">${text}</div>
          ${r.pictures_urls && r.pictures_urls.length ? `<div class="rv__pics">${r.pictures_urls.slice(0, 4).map(pu => `<a href="${esc(pu.huge || pu.original)}" target="_blank" rel="noopener"><img src="${esc(pu.small)}" alt="Customer photo" loading="lazy"></a>`).join('')}</div>` : ''}
          ${r.product_title && sc && r.product_title !== sc.name && r.product_title !== sc.title ? `<p class="rv__prod">Reviewed: ${esc(r.product_title)}</p>` : ''}
        </div>
        <span class="rv__date">${date}</span>
      </li>`;
    }).join('') || '<li class="rv"><p>No reviews yet.</p></li>';
    renderPager(sec, (d.pagination && d.pagination.total_pages) || 1, page);
  } catch (e) { if (my === st.req) list.innerHTML = '<li class="rv"><p>Reviews are unavailable right now.</p></li>'; }
}
function renderPager(sec, total, cur) {
  const nav = $('[data-gp-pager]', sec); if (!nav) return;
  const nums = new Set([1, total, cur - 1, cur, cur + 1].filter(n => n >= 1 && n <= total));
  if (cur <= 3) [2, 3].forEach(n => n <= total && nums.add(n));
  let html = `<button type="button" data-pg="${cur - 1}" ${cur === 1 ? 'disabled' : ''} aria-label="Previous page">‹</button>`, prev = 0;
  [...nums].sort((a, b) => a - b).forEach(n => { if (n - prev > 1) html += '<span class="gap">…</span>'; html += `<button type="button" data-pg="${n}" class="${n === cur ? 'is-on' : ''}" ${n === cur ? 'aria-current="page"' : ''}>${n}</button>`; prev = n; });
  html += `<button type="button" data-pg="${cur + 1}" ${cur === total ? 'disabled' : ''} aria-label="Next page">›</button>`;
  nav.innerHTML = total > 1 ? html : '';
}
let ratingReq = 0;
async function loadMainRating() {
  const m = main(), sc = scent(S.handle); if (!m || !sc || !$('[data-gp-rating]', m)) return;
  const my = ++ratingReq;
  try {
    const d = await (await fetch(jm(SHOP(m.querySelector('[data-judgeme]')), sc.id, 1, 1))).json();
    if (my !== ratingReq) return;
    const rt = $('[data-gp-rating]', m);
    if (!d.number_of_reviews) { if (rt && !(sc.rating > 0)) rt.hidden = true; return; }
    if (rt) rt.hidden = false;
    bind('avg', (+d.average_rating).toFixed(1), m); bind('count', d.number_of_reviews, m); setStars($('.gp-rating .stars', m), +d.average_rating);
  } catch { }
}
function loadCardRatings(scope) {
  $$('[data-gp="xs"] [data-rate]', scope).forEach(async el => {
    if (!once(el, 'Rate')) return;
    const sec = el.closest('[data-gp="xs"]');
    try {
      const d = await (await fetch(jm(SHOP(sec), el.dataset.rate, 1, 1))).json();
      if (d.number_of_reviews) el.innerHTML = `<span class="stars stars--sm" style="--pct:${d.average_rating / 5 * 100}%" aria-hidden="true"></span>${(+d.average_rating).toFixed(1)}`;
    } catch { }
  });
}
async function submitReview(form) {
  const sec = form.closest('[data-gp="reviews"]'), err = $('[data-gp-reverr]', form), fd = new FormData(form);
  const need = ['body', 'name', 'email'].find(k => !String(fd.get(k) || '').trim());
  if (need || !/^\S+@\S+\.\S+$/.test(fd.get('email'))) { if (err) { err.hidden = false; err.textContent = 'Please add your review, name, and a valid email.'; } return; }
  if (err) err.hidden = true;
  const out = new FormData();
  Object.entries({ url: SHOP(sec), shop_domain: SHOP(sec), platform: 'shopify', id: productId(sec), reviewer_name_format: '',
    name: fd.get('name'), email: fd.get('email'), rating: fd.get('rating'), title: fd.get('title') || '', body: fd.get('body') }).forEach(([k, v]) => out.append(k, v));
  const btn = $('[type=submit]', form); btn.disabled = true; const label = btn.textContent; btn.textContent = 'Submitting…';
  try {
    await fetch('https://api.judge.me/api/v1/reviews', { method: 'POST', body: out, mode: 'no-cors' });
    form.reset(); closeModal(); toast('Thank you! Your review was submitted.');
  } catch { if (err) { err.hidden = false; err.textContent = 'Your review could not be submitted. Please try again.'; } }
  btn.disabled = false; btn.textContent = label;
}
function openModal(sec) { const m = $('[data-gp-revmodal]', sec); if (!m) return; m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); setTimeout(() => { const t = $('textarea', m); if (t) t.focus(); }, 50); }
function closeModal() { $$('[data-gp-revmodal].is-open').forEach(m => { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); }); }

/* ---------------- video lightbox (UGC) ---------------- */
function openVideo(card) {
  const sec = card.closest('.gemi-pdp'), b = $('[data-gp-vbox]', sec) || $('[data-gp-vbox]'), v = b && $('video', b);
  if (!v) { window.open(card.dataset.ugc, '_blank'); return; }
  v.src = card.dataset.ugc; b.classList.add('is-open'); b.setAttribute('aria-hidden', 'false'); v.play().catch(() => { });
}
function closeVideo() { $$('[data-gp-vbox].is-open').forEach(b => { const v = $('video', b); if (v) { v.pause(); v.removeAttribute('src'); v.load(); } b.classList.remove('is-open'); b.setAttribute('aria-hidden', 'true'); }); }

/* ---------------- rails (ugc, ingredients, awards, cross-sell) ---------------- */
const railOf = el => $('[data-gp-rail]', el.closest('.gemi-pdp'));
const visibleKids = r => [...r.children].filter(k => !k.hidden && k.offsetParent !== null);
function syncRail(r) {
  if (!r) return;
  r.classList.toggle('is-static', r.scrollWidth <= r.clientWidth + 2);   // no grab cursor when it can't scroll
  const sec = r.closest('.gemi-pdp'), max = r.scrollWidth - r.clientWidth;
  $$('[data-gp-railnav]', sec).forEach(nav => {
    const prev = $('[data-dir="-1"]', nav), next = $('[data-dir="1"]', nav);
    if (prev) prev.disabled = r.scrollLeft <= 2;
    if (next) next.disabled = r.scrollLeft >= max - 2;
  });
  const dots = $('[data-gp-dots]', sec);
  if (dots && r.hasAttribute('data-gp-awards')) {
    const kids = visibleKids(r);
    if (dots.children.length !== kids.length) dots.innerHTML = kids.map((_, i) => `<button type="button" data-award-dot="${i}" aria-label="Show item ${i + 1}"></button>`).join('');
    const i = max <= 0 ? 0 : Math.round(r.scrollLeft / max * (kids.length - 1));
    [...dots.children].forEach((d, j) => d.classList.toggle('is-on', j === i));
  }
}
function bindRail(r) {
  if (!once(r, 'Rail')) { syncRail(r); return; }
  r.addEventListener('scroll', () => syncRail(r), { passive: true });
  // arrows/dots must be re-measured once images load or the rail resizes (lazy images change scrollWidth)
  r.addEventListener('load', () => syncRail(r), true);
  if ('ResizeObserver' in window) new ResizeObserver(() => syncRail(r)).observe(r);
  // click-and-drag with a mouse; touch keeps native scrolling
  let x0 = 0, s0 = 0, down = false, moved = false;
  r.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse' || e.button || r.scrollWidth <= r.clientWidth + 2) return; down = true; moved = false; x0 = e.clientX; s0 = r.scrollLeft; });
  addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - x0; if (Math.abs(dx) > 4) { moved = true; r.classList.add('is-drag'); } if (moved) r.scrollLeft = s0 - dx; });
  addEventListener('pointerup', () => {
    if (!down) return; down = false;
    if (moved) { r.classList.remove('is-drag'); const kids = visibleKids(r); if (!kids.length) return; const base = kids[0].offsetLeft; const near = kids.reduce((a, k) => Math.abs(k.offsetLeft - base - r.scrollLeft) < Math.abs(a.offsetLeft - base - r.scrollLeft) ? k : a, kids[0]); r.scrollTo({ left: near.offsetLeft - base, behavior: 'smooth' }); }
  });
  r.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  syncRail(r);
}
function scrollToKid(r, kid) { const kids = visibleKids(r); if (!kids.length || !kid) return; r.scrollTo({ left: kid.offsetLeft - kids[0].offsetLeft, behavior: 'smooth' }); }

/* ---------------- gallery ---------------- */
const galIndex = tr => { const slides = $$('.gal__slide', tr); if (slides.length < 2) return 0; const step = slides[1].offsetLeft - slides[0].offsetLeft || tr.clientWidth; return Math.max(0, Math.min(slides.length - 1, Math.round(tr.scrollLeft / step))); };
function galGo(m, i) {
  const tr = $('[data-gp-track]', m); if (!tr) return;
  const slides = $$('.gal__slide', tr); if (!slides.length) return;
  i = Math.max(0, Math.min(slides.length - 1, i));
  tr.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
}
function galSync(m) {
  const tr = $('[data-gp-track]', m); if (!tr) return;
  const slides = $$('.gal__slide', tr), i = galIndex(tr), max = tr.scrollWidth - tr.clientWidth;
  $$('.gal__thumb', m).forEach((b, j) => { b.classList.toggle('is-on', j === i); if (j === i) { const th = b.parentElement; if (th && (b.offsetLeft < th.scrollLeft || b.offsetLeft + b.offsetWidth > th.scrollLeft + th.clientWidth)) th.scrollTo({ left: b.offsetLeft - 12, behavior: 'smooth' }); } });
  const prev = $('[data-gal-dir="-1"]', m), next = $('[data-gal-dir="1"]', m);
  if (prev) prev.disabled = tr.scrollLeft <= 2;
  if (next) next.disabled = tr.scrollLeft >= max - 2 || slides.length < 2;
  $$('.gal__nav', m).forEach(b => { b.hidden = slides.length < 2; });
  const badge = $('.gal__badge', m); if (badge) badge.classList.toggle('is-hidden', tr.scrollLeft > 20);
  slides.forEach((sl, j) => { const v = $('video', sl); if (v) j === i ? v.play().catch(() => { }) : v.pause(); });
}
// sticky only while the whole gallery (image + thumbnails) fits on screen; otherwise it scrolls with the page
function galFit(m) {
  const g = $('[data-gp-gallery]', m); if (!g) return;
  g.classList.remove('gal--flow');
  if (getComputedStyle(g).position !== 'sticky') return;
  const top = parseFloat(getComputedStyle(g).top) || 0;
  g.classList.toggle('gal--flow', g.offsetHeight + top > innerHeight);
}
function bindGallery(m) {
  const tr = $('[data-gp-track]', m); if (!tr || !once(tr, 'Gal')) return;
  tr.addEventListener('scroll', () => galSync(m), { passive: true });
  tr.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); galGo(m, galIndex(tr) + (e.key === 'ArrowRight' ? 1 : -1)); } });
  bindRail(tr);
  const th = $('[data-gp-thumbs]', m); if (th) bindRail(th);
  tr.addEventListener('load', () => galFit(m), true);
  galSync(m); galFit(m);
}

/* ---------------- UGC hover previews (desktop) ---------------- */
function bindUGC(scope) {
  if (!matchMedia('(hover: hover)').matches) return;
  $$('.ugc__card[data-ugc]', scope).forEach(card => {
    if (!once(card, 'Hover')) return;
    let v;
    card.addEventListener('mouseenter', () => { if (!v) { v = document.createElement('video'); Object.assign(v, { src: card.dataset.ugc, muted: true, loop: true, playsInline: true, preload: 'none' }); v.setAttribute('aria-hidden', 'true'); v.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover'; card.insertBefore(v, $('.ugc__play', card)); } v.play().catch(() => { }); });
    card.addEventListener('mouseleave', () => v && v.pause());
  });
}

/* ---------------- init (page load + every editor re-render) ---------------- */
let revIO;
function init(scope = document) {
  const d = data();
  if (!S.handle || !scent(S.handle)) {
    const q = new URLSearchParams(location.search).get('scent');
    const any = $('[data-gp-handle]');
    S.handle = (q && scent(q) && q) || (d && d.default) || (any && any.dataset.gpHandle) || null;
  }
  const m = main();
  if (m) {
    bindGallery(m);
    $$('[data-gp-bundles] .bun', m).forEach(updateBundle);
    const sc = scent(S.handle);
    if (sc && S.handle !== m.dataset.gpHandle) renderMain(sc); else if (sc) renderVariant(sc);
    setPurchase(S.purchase);
    m.classList.remove('gp-pending');
    if (once(m, 'Rating')) loadMainRating();
    // landing on ?variant=: open the gallery on that variant's image (ads and shared links point at a specific set)
    if (once(m, 'VarImg')) {
      const vq = new URLSearchParams(location.search).get('variant'), vsc = scent(S.handle);
      if (vq && vsc && String(vsc.variant.id) === vq && vsc.variant.image) requestAnimationFrame(() => { jumpToImage(vsc.variant.image, true); galSync(m); });
    }
  }
  applyScentToSections();
  keepPreviewParam(document);
  $$('[data-gp-rail]', scope).forEach(bindRail);
  bindUGC(scope);
  loadCardRatings(scope);
  const revs = $$('[data-gp="reviews"]', scope).concat(scope.matches && scope.matches('[data-gp="reviews"]') ? [scope] : []);
  revs.forEach(sec => {
    // load when it comes near the viewport, or after 3s regardless (cheap request, keeps the rating fresh)
    setTimeout(() => { if (!sec.dataset.gpLoaded && sec.isConnected) loadReviews(sec, 1); }, 3000);
    if ('IntersectionObserver' in window) {
      revIO = revIO || new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { revIO.unobserve(en.target); if (!en.target.dataset.gpLoaded) loadReviews(en.target, 1); } }), { rootMargin: '800px' });
      revIO.observe(sec);
    } else loadReviews(sec, 1);
  });
}
G.init = init; G.switchScent = h => switchScent(h, true); G.state = S;

/* ---------------- events (delegated once, so re-rendered sections just work) ---------------- */
document.addEventListener('click', async e => {
  const t = e.target instanceof Element ? e.target : null;
  if (!t || !t.closest('.gemi-pdp')) return;
  let el;
  if ((el = t.closest('[data-gal-dir]'))) { const m = el.closest('[data-gp="main"]'), tr = $('[data-gp-track]', m); galGo(m, galIndex(tr) + +el.dataset.galDir); return; }
  if ((el = t.closest('[data-gp-vbox]')) && !t.closest('video')) { closeVideo(); return; }
  if ((el = t.closest('.gp-vbtn'))) {
    const fs = el.closest('.gp-opt'), i = +fs.dataset.optIndex, sc = scent(S.handle); if (!sc) return;
    const want = [...(sc.variant.options || [])]; want[i] = el.dataset.value;
    const same = x => (x.options || []).every((o, j) => o === want[j]);
    const v = sc.variants.find(same) || sc.variants.find(x => x.available && (x.options || [])[i] === want[i]) || sc.variants.find(x => (x.options || [])[i] === want[i]);
    if (!v) return;
    S.vsel[sc.handle] = v.id; renderVariant(sc);
    if (v.image) jumpToImage(v.image);
    if (history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.pathname + u.search + u.hash); }
    return;
  }
  if ((el = t.closest('[data-plan]'))) { e.preventDefault(); S.plan = String(el.dataset.plan); setPurchase('sub'); renderPlans(scent(S.handle)); return; }
  if ((el = t.closest('[data-qty]'))) { const q = $('[data-gp-qty]', el.closest('.atc')); if (q) q.value = clampQty((+q.value || 1) + +el.dataset.qty); syncExpress(); return; }
  if ((el = t.closest('[data-gp-atc]'))) {
    const sc = scent(S.handle); if (!sc || !sc.variant.available) return;
    const q = $('[data-gp-qty]', el.closest('.atc'));
    const item = { id: +sc.variant.id, quantity: clampQty(q ? q.value : 1) };
    if (S.purchase === 'sub' && S.plan) item.selling_plan = +S.plan;
    withButton(el, () => addItems([item]));
    return;
  }
  if ((el = t.closest('.bun__head'))) { const bun = el.closest('.bun'), open = !bun.classList.contains('is-open'); bun.classList.toggle('is-open', open); el.setAttribute('aria-expanded', open ? 'true' : 'false'); return; }
  if ((el = t.closest('[data-step]'))) {
    const bun = el.closest('.bun'), k = el.closest('.pick').dataset.k, sel = bundleState(bun);
    sel[k] = Math.max(0, (sel[k] || 0) + +el.dataset.step); updateBundle(bun); return;
  }
  if ((el = t.closest('.bun__add'))) {
    const bun = el.closest('.bun'), sel = bundleState(bun);
    const items = $$('.pick', bun).filter(li => sel[li.dataset.k] > 0).map(li => ({ id: +li.dataset.variant, quantity: sel[li.dataset.k] }));
    if (!items.length) return;
    el.disabled = true;
    try { await addItems(items); bun._gpSel = {}; bun.classList.remove('is-open'); const h = $('.bun__head', bun); if (h) h.setAttribute('aria-expanded', 'false'); } catch { }
    updateBundle(bun);
    return;
  }
  if ((el = t.closest('[data-xs]'))) { withButton(el, () => addItems([{ id: +el.dataset.xs, quantity: 1 }])); return; }
  if ((el = t.closest('[data-ugc]'))) { openVideo(el); return; }
  if (t.closest('[data-close-vbox]')) { closeVideo(); return; }
  if ((el = t.closest('[data-pg]'))) { const sec = el.closest('[data-gp="reviews"]'); loadReviews(sec, +el.dataset.pg); const r = $('.rev', sec); if (r) r.scrollIntoView({ behavior: 'smooth' }); return; }
  if ((el = t.closest('[data-gp-write]'))) { openModal(el.closest('[data-gp="reviews"]')); return; }
  if (t.closest('[data-close-rev]')) { closeModal(); return; }
  if ((el = t.closest('[data-go]'))) { const tr = $('[data-gp-track]', el.closest('[data-gp="main"]')); if (tr) tr.scrollTo({ left: tr.clientWidth * +el.dataset.go, behavior: 'smooth' }); return; }
  if ((el = t.closest('[data-gp-railnav] button'))) { const r = railOf(el); if (r) r.scrollBy({ left: +el.dataset.dir * r.clientWidth * .75, behavior: 'smooth' }); return; }
  if ((el = t.closest('[data-gp-railarrow]'))) { const r = railOf(el); if (r) r.scrollBy({ left: r.clientWidth * .8, behavior: 'smooth' }); return; }
  if ((el = t.closest('[data-award-dot]'))) { const r = railOf(el); if (r) scrollToKid(r, visibleKids(r)[+el.dataset.awardDot]); return; }
});
document.addEventListener('change', e => {
  const t = e.target;
  if (!(t instanceof Element) || !t.closest('.gemi-pdp')) return;
  if (t.name && t.name.indexOf('purchase-') === 0) setPurchase(t.value);
  else if (t.matches('[data-gp-sort]')) { const sec = t.closest('[data-gp="reviews"]'); (sec._gp || (sec._gp = { req: 0 })).sort = t.value; loadReviews(sec, 1); }
  else if (t.matches('[data-gp-qty]')) { t.value = clampQty(t.value); syncExpress(); }
});
document.addEventListener('submit', e => { const f = e.target; if (f instanceof Element && f.matches('[data-gp-revform]')) { e.preventDefault(); submitReview(f); } });
document.addEventListener('keydown', e => { if (e.key !== 'Escape') return; closeVideo(); closeModal(); });
addEventListener('resize', () => { $$('[data-gp-rail]').forEach(syncRail); const m = main(); if (m) { galFit(m); galSync(m); } }, { passive: true });

// scent swatches are links to each product page: warm the next page on hover / touch so it opens instantly,
// and keep a template preview (?view=) when the team previews the theme
const prefetched = new Set();
function prefetch(a) {
  if (!a || !a.href || prefetched.has(a.href) || a.getAttribute('aria-current')) return;
  prefetched.add(a.href);
  const l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; l.as = 'document'; document.head.appendChild(l);
}
['pointerenter', 'touchstart', 'focusin'].forEach(ev => document.addEventListener(ev, e => { const a = e.target instanceof Element && e.target.closest('.scent__row a.sw'); if (a) prefetch(a); }, { passive: true, capture: true }));
function keepPreviewParam(scope) {
  const view = new URLSearchParams(location.search).get('view'); if (!view) return;
  $$('.scent__row a.sw', scope).forEach(a => { const u = new URL(a.href, location.href); u.searchParams.set('view', view); a.href = u.pathname + u.search; });
}

/* ---------------- theme editor ---------------- */
document.addEventListener('shopify:section:load', e => init(e.target));
document.addEventListener('shopify:block:select', e => {
  const b = e.target; if (!(b instanceof Element) || !b.closest('.gemi-pdp')) return;
  const panel = b.closest('[data-scent-panel]');
  if (panel) $$('[data-scent-panel]', panel.parentElement).forEach(p => { p.hidden = p !== panel; });
  const r = b.closest('[data-gp-rail]'); if (r) scrollToKid(r, b);
  if (b.tagName === 'DETAILS') b.open = true;
  if (b.classList.contains('pc')) b.hidden = false;
});

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
})();
